<template>
  <form @submit.prevent="handleSubmit">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Send image to Slack</p>
      </header>
      <section class="modal-card-body">
        <o-field label="Message file">
          <o-input tabindex="0" id="message-file"/>
        </o-field>
<!--        <input type="file" id="file"/>-->
<!--        <img src="" width="200" style="display:none;" />-->

        <div class="drop-zone-container">
          <div class="drop-zone">
            <span class="drop-zone__prompt">Drop/Paste image here or click to upload</span>
            <input type="file" name="myFile" accept="image/*" class="drop-zone__input">
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
        <input type="submit" class="button is-primary" value="Save">
      </footer>
    </div>
  </form>
</template>

<script>
import {post_file} from "../../modules/slack/slack_api";

export default {
  name: "FileSend",
  mounted() {
    this.changeImage();
  },
  methods: {
    handleSubmit(e) {
      const editor = e.target
      const editor_clone = editor.cloneNode(true)
      post_file(editor_clone, this.$route.params.id || this.$route.params.selected_id)
          .then(() => {
            setTimeout(() => {
              this.successMessage('File has been sent')
              this.$parent.$parent.$emit('update:active', false)
            }, 3000)
            setTimeout(() => {
              $('.slack-chat').animate({scrollTop: $(".slack-chat")[0].scrollHeight},"fast");
            }, 3000)
            setTimeout(() => {
              $('.slack-chat').animate({scrollTop: $(".slack-chat")[0].scrollHeight},"fast");
            }, 4000)
            setTimeout(() => {
              $('.slack-chat').animate({scrollTop: $(".slack-chat")[0].scrollHeight},"fast");
            }, 5000)
            setTimeout(() => {
              $('.slack-chat').animate({scrollTop: $(".slack-chat")[0].scrollHeight},"fast");
            }, 6000)
            setTimeout(() => {
              $('.slack-chat').animate({scrollTop: $(".slack-chat")[0].scrollHeight},"fast");
            }, 7000)
          })
          .catch(err => err)
    },

    changeImage(){
      // $('#file').change( function(event) {
      //   var tmppath = URL.createObjectURL(event.target.files[0]);
      //   $("img").fadeIn("fast").attr('src',URL.createObjectURL(event.target.files[0]))
      // })

      document.querySelectorAll(".drop-zone__input").forEach((inputElement) => {
        const dropZoneElement = inputElement.closest(".drop-zone");

        dropZoneElement.addEventListener("click", (e) => {
          inputElement.click();
        });

        document.addEventListener('paste', function (evt) {
          // Get the data of clipboard
          const clipboardData = evt.clipboardData || window.clipboardData;
          if (clipboardData.files.length && clipboardData.files[0].type.startsWith("image/")) {
            inputElement.files = clipboardData.files;
            updateThumbnail(dropZoneElement, clipboardData.files[0]);
          }

          dropZoneElement.classList.remove("drop-zone--over");

        });

        inputElement.addEventListener("change", (e) => {
          if (inputElement.files.length) {
            updateThumbnail(dropZoneElement, inputElement.files[0]);
          }
        });

        dropZoneElement.addEventListener("dragover", (e) => {
          e.preventDefault();
          dropZoneElement.classList.add("drop-zone--over");
        });

        ["dragleave", "dragend"].forEach((type) => {
          dropZoneElement.addEventListener(type, (e) => {
            dropZoneElement.classList.remove("drop-zone--over");
          });
        });

        dropZoneElement.addEventListener("drop", (e) => {
          e.preventDefault();

          if (e.dataTransfer.files.length && e.dataTransfer.files[0].type.startsWith("image/")) {
            inputElement.files = e.dataTransfer.files;
            updateThumbnail(dropZoneElement, e.dataTransfer.files[0]);
          }

          dropZoneElement.classList.remove("drop-zone--over");
        });
      });

      /**
       * Updates the thumbnail on a drop zone element.
       *
       * @param {HTMLElement} dropZoneElement
       * @param {File} file
       */
      function updateThumbnail(dropZoneElement, file) {
        let thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");

        // First time - remove the prompt
        if (dropZoneElement.querySelector(".drop-zone__prompt")) {
          dropZoneElement.querySelector(".drop-zone__prompt").remove();
        }

        // First time - there is no thumbnail element, so lets create it
        if (!thumbnailElement) {
          thumbnailElement = document.createElement("img");
          thumbnailElement.classList.add("drop-zone__thumb");
          dropZoneElement.appendChild(thumbnailElement);
        }

        thumbnailElement.dataset.label = file.name;

        // Show thumbnail for image files
        if (file.type.startsWith("image/")) {
          const reader = new FileReader();



          reader.readAsDataURL(file);
          reader.onload = () => {
            // thumbnailElement.style.backgroundImage = `url('${reader.result}')`;
            $(".drop-zone__thumb").attr("width", 300)
            $(".drop-zone__thumb").attr("src", reader.result)
          };
        } else {
          $(".drop-zone__thumb").attr("src", "")
        }
      }

    },
  },

}
</script>

<style scoped>

.drop-zone-container{
  display: flex;
  justify-content: center;
}

.drop-zone {
  max-width: 50%;
  height: auto;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: "Quicksand", sans-serif;
  font-weight: 500;
  font-size: 20px;
  cursor: pointer;
  color: #cccccc;
  border: 4px dashed #009578;
  border-radius: 10px;
}

.drop-zone--over {
  border-style: solid;
}

.drop-zone__input {
  display: none;
}

.drop-zone__thumb {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
  background-color: #cccccc;
  background-size: cover;
  position: relative;
}

.drop-zone__thumb::after {
  content: attr(data-label);
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 0;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.75);
  font-size: 14px;
  text-align: center;
}

</style>